// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/GTEestiBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/AvenirBook.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/AvenirBlack.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/AvenirOblique.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/creditcard.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/paypal.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/bizum.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/googlepay.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/redirect.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*******************************************************
 *                                                     *
 *                VIAJES TEIDE                         *
 *                                                     *
 *        developed: Javier Vega Martinez              *
 *        contact: info@emdbwebprojects.com            *
 *        copyright - 2014-2024                        *
 *                                                     *
 *******************************************************/
/* width */
/* fonts */
@font-face {
  font-family: GTEestiBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: AvenirBook;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: AvenirBlack;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: AvenirOblique;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
/* debug */
.debug-Ha9vG {
  background-color: #ff7f50;
}
.debug2-DjdLL {
  background-color: #6495ed;
}
.cartForm-Um0tD {
  container: cartForm / inline-size;
  position: relative;
  width: 100%;
  margin: 0px;
}
.cartForm-Um0tD .errors-V572M {
  height: auto;
  margin-bottom: 20px;
  border: 1px solid #E1E1E1;
  border-radius: 0px;
  background-color: #FF6698;
}
.cartForm-Um0tD .errors-V572M .error-HI_lG {
  display: block;
  margin: 10px 0px 0px 10px;
}
.cartForm-Um0tD .errors-V572M .error-HI_lG:before {
  content: "- ";
}
.cartForm-Um0tD .errors-V572M .error-HI_lG:first-child {
  margin-top: 10px;
}
.cartForm-Um0tD .errors-V572M .error-HI_lG:last-child {
  margin-bottom: 10px;
}
.cartForm-Um0tD .clientInfo-uDFaD {
  box-sizing: border-box;
  margin: 0px 0px 0px 0px;
  padding: 20px;
  border-radius: 20px;
  font-family: AvenirBook;
  font-size: 1em;
  background-color: #E1E1E1;
}
.cartForm-Um0tD .clientInfo-uDFaD h2 {
  font-family: AvenirBlack;
  font-size: 1.0625em;
  color: #000000;
}
.cartForm-Um0tD .clientInfo-uDFaD .inputs-JufC4 {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}
.cartForm-Um0tD .clientInfo-uDFaD .inputs-JufC4 input {
  flex: 1;
  min-width: 250px;
  height: 42px;
  padding-left: 10px;
  border-radius: 20px;
  font-family: AvenirBook;
  font-size: 1em;
  color: #666666;
  border: none;
}
.cartForm-Um0tD .clientInfo-uDFaD .inputs-JufC4 input:invalid {
  border-color: #FF6698;
}
.cartForm-Um0tD .clientInfo-uDFaD .inputs-JufC4 textarea {
  flex: 2;
  box-sizing: border-box;
  min-width: 100%;
  height: 100px;
  padding: 2%;
  border-radius: 20px;
  font-family: AvenirBook;
  font-size: 1em;
  color: #666666;
  border: none;
}
.cartForm-Um0tD .clientInfo-uDFaD .cartInfo-Sh8g9 {
  margin-top: 20px;
  font-size: 0.875em;
  line-height: 20px;
  text-align: justify;
}
.cartForm-Um0tD .clientInfo-uDFaD .cartInfo-Sh8g9 b {
  font-family: AvenirBook;
}
.cartForm-Um0tD .paids-GRZ8O {
  margin: 20px 0px 0px 0px;
  padding: 20px;
  border-radius: 20px;
  font-family: AvenirBook;
  font-size: 1em;
  background-color: #E1E1E1;
}
.cartForm-Um0tD .paids-GRZ8O .title-l7Rhj {
  height: 50px;
  margin-bottom: 20px;
  font-family: AvenirBlack;
  font-size: 1.0625em;
  color: #000000;
}
.cartForm-Um0tD .paids-GRZ8O .title-l7Rhj input {
  margin-top: 30px;
  height: 45px;
  padding-left: 10px;
  border-radius: 20px;
}
.cartForm-Um0tD .paids-GRZ8O .title-l7Rhj input[type=radio] {
  width: 20px;
  height: 20px;
  margin-top: 15px;
  margin-right: 10px;
}
.cartForm-Um0tD .paids-GRZ8O input.btnsubmit-jUyBq {
  max-width: 200px;
  padding: 0px;
  margin: 0px 0px 0px 0px;
  height: 45px;
  line-height: 50px;
  border-radius: 20px;
  font-family: AvenirBlack;
  font-size: 1em;
  background-color: #33CCFF;
  text-align: center;
  cursor: pointer;
  border: none;
}
.cartForm-Um0tD .paids-GRZ8O input.btnsubmit-jUyBq:disabled {
  background-color: #999999;
  cursor: initial;
}
.cartForm-Um0tD .paids-GRZ8O .creditcard-WU_A6 {
  margin-bottom: 20px;
}
.cartForm-Um0tD .paids-GRZ8O .creditcard-WU_A6 .inputs-JufC4 {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(2, minmax(150px, 1fr));
}
.cartForm-Um0tD .paids-GRZ8O .creditcard-WU_A6 .inputs-JufC4 input {
  width: 100%;
  height: 45px;
  padding-left: 10px;
  border-radius: 20px;
  box-sizing: border-box;
  font-family: AvenirBook;
  font-size: 1em;
  color: #666666;
  border: none;
}
.cartForm-Um0tD .paids-GRZ8O .creditcard-WU_A6 .inputs-JufC4 .expirydate-nKCJj {
  display: flex;
  gap: 20px;
  width: 100%;
}
.cartForm-Um0tD .paids-GRZ8O .creditcard-WU_A6 .inputs-JufC4 .expirydate-nKCJj input {
  flex: 1;
}
.cartForm-Um0tD .paids-GRZ8O .creditcard-WU_A6 .inputs-JufC4 input.btnsubmit-jUyBq {
  justify-self: end;
  color: #FFFFFF;
  font-family: AvenirBlack;
}
.cartForm-Um0tD .paids-GRZ8O .securecreditcard-PDfwS .inputs-JufC4 {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(2, minmax(150px, 1fr));
}
.cartForm-Um0tD .paids-GRZ8O .securecreditcard-PDfwS .inputs-JufC4 input {
  width: 100%;
}
.cartForm-Um0tD .paids-GRZ8O .securecreditcard-PDfwS .inputs-JufC4 input.btnsubmit-jUyBq {
  justify-self: end;
  color: #FFFFFF;
  font-family: AvenirBlack;
}
.cartForm-Um0tD .paids-GRZ8O .paypal-S4KGb .inputs-JufC4 {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(2, minmax(150px, 1fr));
}
.cartForm-Um0tD .paids-GRZ8O .paypal-S4KGb .inputs-JufC4 input {
  width: 100%;
}
.cartForm-Um0tD .paids-GRZ8O .paypal-S4KGb .inputs-JufC4 input.btnsubmit-jUyBq {
  justify-self: end;
  color: #FFFFFF;
  font-family: AvenirBlack;
}
.cartForm-Um0tD .paids-GRZ8O .bizum-bIQzn .inputs-JufC4 {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(2, minmax(150px, 1fr));
}
.cartForm-Um0tD .paids-GRZ8O .bizum-bIQzn .inputs-JufC4 input {
  width: 100%;
}
.cartForm-Um0tD .paids-GRZ8O .bizum-bIQzn .inputs-JufC4 input.btnsubmit-jUyBq {
  justify-self: end;
  color: #FFFFFF;
  font-family: AvenirBlack;
}
.cartForm-Um0tD .paids-GRZ8O .googlepay-r2U7r .inputs-JufC4 {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(2, minmax(150px, 1fr));
}
.cartForm-Um0tD .paids-GRZ8O .googlepay-r2U7r .inputs-JufC4 input {
  width: 100%;
}
.cartForm-Um0tD .paids-GRZ8O .googlepay-r2U7r .inputs-JufC4 input.btnsubmit-jUyBq {
  justify-self: end;
  color: #FFFFFF;
  font-family: AvenirBlack;
}
.cartForm-Um0tD .paids-GRZ8O .creditcardicon-FynLh {
  display: inline-block;
  width: 93px;
  height: 25px;
  margin-left: 15px;
  vertical-align: middle;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) 0px 0px;
}
.cartForm-Um0tD .paids-GRZ8O .paypalicon-Jy8EE {
  display: inline-block;
  width: 90px;
  height: 26px;
  margin-left: 15px;
  vertical-align: middle;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) 0px 0px;
}
.cartForm-Um0tD .paids-GRZ8O .bizumicon-HrK04 {
  display: inline-block;
  width: 100px;
  height: 32px;
  margin-left: 15px;
  vertical-align: middle;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) 0px 0px;
}
.cartForm-Um0tD .paids-GRZ8O .googlepayicon-VGN3S {
  display: inline-block;
  width: 70px;
  height: 37px;
  margin-left: 15px;
  vertical-align: middle;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) 0px 0px;
}
.cartForm-Um0tD .paids-GRZ8O .conditions-IVhCY {
  font-size: 0.875em;
}
.modalPay-htdke {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}
.modalPay-htdke .modalPayBackground-BRHyA {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #333333;
  opacity: 0.8;
}
.modalPay-htdke .modalPayContent-TNEIC {
  position: absolute;
  width: 400px;
  min-height: 250px;
  padding-block: 20px;
  background-color: #FFFFFF;
  border-radius: 10px;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.modalPay-htdke .modalPayContent-TNEIC .modalPayImg-zkU2p {
  margin: 20px auto;
}
.modalPay-htdke .modalPayContent-TNEIC .modalPayText-esM14 {
  margin-bottom: 5px;
  color: #666666;
}
.modalPay-htdke .modalPayContent-TNEIC .modalPayGif-DcNZO {
  width: 400px;
  height: 50px;
  margin-top: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) -200px -30px;
}
@container cartForm (inline-size < 450px) {
  .cartForm-Um0tD .paids-GRZ8O .creditcard-WU_A6 .inputs-JufC4 input {
    font-size: 0.9375em;
  }
  .cartForm-Um0tD .paids-GRZ8O .creditcard-WU_A6 .inputs-JufC4 .expirydate-nKCJj {
    font-size: 0.9375em;
  }
  .cartForm-Um0tD .paids-GRZ8O .creditcardicon-FynLh {
    margin-top: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/VTCartForm/VTCartForm.module.less","webpack://./src/assets/css/theme.less"],"names":[],"mappings":"AAAA;;;;;;;;wDAQwD;AACxD,UAAU;AACV,UAAU;ACwBV;EAAY,wBAAA;EAA0B,4CAAA;ADpBtC;ACqBA;EAAY,uBAAA;EAAyB,4CAAA;ADjBrC;ACkBA;EAAY,wBAAA;EAA0B,4CAAA;ADdtC;ACeA;EAAY,0BAAA;EAA4B,4CAAA;ADXxC;AACA,UAAU;ACiBV;EAAQ,yBAAA;ADdR;ACeA;EAAS,yBAAA;ADZT;AA/BA;EAAY,iCAAA;EAAmC,kBAAA;EAAoB,WAAA;EAAa,WAAA;AAqChF;AArCA;EACY,YAAA;EAAc,mBAAA;EAAqB,yBAAA;EAA+B,kBAAA;EAAoB,yBAAA;AA2ClG;AA5CA;EAEa,cAAA;EAAgB,yBAAA;AA8C7B;AAhDA;EAGoB,aAAA;AAgDpB;AAnDA;EAIyB,gBAAA;AAkDzB;AAtDA;EAKwB,mBAAA;AAoDxB;AAzDA;EAQgB,sBAAA;EAAwB,uBAAA;EAAyB,aAAA;EAAgB,mBAAA;EAAqB,uBAAA;EC8BpG,cAAA;ED9B6I,yBAAA;AA0D/I;AAlEA;EASS,wBAAA;EC6BP,mBAAA;ED7BiD,cAAA;AA8DnD;AAvEA;EAUc,aAAA;EAAe,SAAA;EAAW,eAAA;AAkExC;AA5EA;EAWc,OAAA;EAAS,gBAAA;EAAkB,YAAA;EAAc,kBAAA;EAAoB,mBAAA;EAAqB,uBAAA;EC2B9F,cAAA;ED3BuI,cAAA;EAAoB,YAAA;AA4E7J;AAvFA;EAYsB,qBAAA;AA8EtB;AA1FA;EAaiB,OAAA;EAAS,sBAAA;EAAwB,eAAA;EAAiB,aAAA;EAAe,WAAA;EAAa,mBAAA;EAAqB,uBAAA;ECyBlH,cAAA;EDzB2J,cAAA;EAAoB,YAAA;AAyFjL;AAtGA;EAgBe,gBAAA;ECsBb,kBAAA;EDtB+C,iBAAA;EAAmB,mBAAA;AA4FpE;AA5GA;EAiBU,uBAAA;AA8FV;AA/GA;EAqBU,wBAAA;EAA0B,aAAA;EAAe,mBAAA;EAAqB,uBAAA;ECiBtE,cAAA;EDjB+G,yBAAA;AAkGjH;AAvHA;EAsBY,YAAA;EAAc,mBAAA;EAAoB,wBAAA;ECgB5C,mBAAA;EDhBsF,cAAA;AAwGxF;AA9HA;EAuBY,gBAAA;EAAiB,YAAA;EAAc,kBAAA;EAAoB,mBAAA;AA6G/D;AApIA;EAwB0B,WAAA;EAAa,YAAA;EAAc,gBAAA;EAAiB,kBAAA;AAkHtE;AA1IA;EA2BsB,gBAAA;EAAkB,YAAA;EAAc,uBAAA;EAAyB,YAAA;EAAa,iBAAA;EAAkB,mBAAA;EAAqB,wBAAA;ECWjI,cAAA;EDX2K,yBAAA;EAA+B,kBAAA;EAAoB,eAAA;EAAiB,YAAA;AA6HjP;AAxJA;EA4B+B,yBAAA;EAA+B,eAAA;AAgI9D;AA5JA;EA8BkB,mBAAA;AAiIlB;AA/JA;EA+BgB,aAAA;EAAe,SAAA;EAAW,oDAAA;AAqI1C;AApKA;EAgCgB,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,mBAAA;EAAqB,sBAAA;EAAwB,uBAAA;ECM1G,cAAA;EDNmJ,cAAA;EAAoB,YAAA;AA+IzK;AA/KA;EAiCsB,aAAA;EAAe,SAAA;EAAW,WAAA;AAmJhD;AApLA;EAkCkB,OAAA;AAqJlB;AAvLA;EAoC0B,iBAAA;EAAmB,cAAA;EAAgB,wBAAA;AAwJ7D;AA5LA;EAyCgB,aAAA;EAAe,SAAA;EAAW,oDAAA;AAwJ1C;AAjMA;EA0CgB,WAAA;AA0JhB;AApMA;EA2C0B,iBAAA;EAAmB,cAAA;EAAgB,wBAAA;AA8J7D;AAzMA;EAgDc,aAAA;EAAe,SAAA;EAAW,oDAAA;AA8JxC;AA9MA;EAiDc,WAAA;AAgKd;AAjNA;EAkDyB,iBAAA;EAAmB,cAAA;EAAgB,wBAAA;AAoK5D;AAtNA;EAuDc,aAAA;EAAe,SAAA;EAAW,oDAAA;AAoKxC;AA3NA;EAwDc,WAAA;AAsKd;AA9NA;EAyDyB,iBAAA;EAAmB,cAAA;EAAgB,wBAAA;AA0K5D;AAnOA;EA8Dc,aAAA;EAAe,SAAA;EAAW,oDAAA;AA0KxC;AAxOA;EA+Dc,WAAA;AA4Kd;AA3OA;EAgEyB,iBAAA;EAAmB,cAAA;EAAgB,wBAAA;AAgL5D;AAhPA;EAoEqB,qBAAA;EAAuB,WAAA;EAAa,YAAA;EAAc,iBAAA;EAAmB,sBAAA;EAAwB,2DAAA;AAoLlH;AAxPA;EAqEiB,qBAAA;EAAuB,WAAA;EAAa,YAAA;EAAc,iBAAA;EAAmB,sBAAA;EAAwB,2DAAA;AA2L9G;AAhQA;EAsEgB,qBAAA;EAAuB,YAAA;EAAc,YAAA;EAAc,iBAAA;EAAmB,sBAAA;EAAwB,2DAAA;AAkM9G;AAxQA;EAuEoB,qBAAA;EAAuB,WAAA;EAAa,YAAA;EAAc,iBAAA;EAAmB,sBAAA;EAAwB,2DAAA;AAyMjH;AAhRA;ECsCE,kBAAA;AD6OF;AApMA;EAAU,eAAA;EAAgB,MAAA;EAAO,OAAA;EAAQ,WAAA;EAAa,YAAA;EAAc,YAAA;AA4MpE;AA5MA;EACsB,kBAAA;EAAoB,MAAA;EAAO,OAAA;EAAQ,WAAA;EAAa,YAAA;EAAc,yBAAA;EAA+B,YAAA;AAoNnH;AArNA;EAEmB,kBAAA;EAAoB,YAAA;EAAc,iBAAA;EAAmB,mBAAA;EAAqB,yBAAA;EAA2B,mBAAA;EAAqB,kBAAA;EACzI,QAAA;EAAU,SAAA;EACV,gCAAA;AA6NJ;AAjOA;EAKiB,iBAAA;AA+NjB;AApOA;EAMkB,kBAAA;EAAmB,cAAA;AAkOrC;AAxOA;EAOiB,YAAA;EAAa,YAAA;EAAc,gBAAA;EAAkB,gEAAA;AAuO9D;AAnOA;EACE;ICrDA,mBAAA;ED2RA;EAtOA;ICrDA,mBAAA;ED8RA;EAzOA;IAQoB,gBAAA;EAoOpB;AACF","sourcesContent":["@import \"../../assets/css/theme\";\n\n.cartForm { container: cartForm / inline-size; position: relative; width: 100%; margin: 0px;\n  .errors { height: auto; margin-bottom: 20px; border: 1px solid @colorgris1; border-radius: 0px; background-color: #FF6698;\n    .error { display: block; margin: 10px 0px 0px 10px; }\n    .error:before { content: \"- \"; }\n    .error:first-child { margin-top: 10px; }\n    .error:last-child { margin-bottom: 10px; }\n  }\n\n  .clientInfo { box-sizing: border-box; margin: 0px 0px 0px 0px; padding: 20px;  border-radius: 20px; font-family: AvenirBook; .font-base(16); background-color: @colorgris1;\n    h2 { font-family: AvenirBlack; .font-base(17); color: #000000; }\n    .inputs { display: flex; gap: 20px; flex-wrap: wrap;\n      input { flex: 1; min-width: 250px; height: 42px; padding-left: 10px; border-radius: 20px; font-family: AvenirBook; .font-base(16); color: @colorgris3; border: none; }\n      input:invalid { border-color: #FF6698; }\n      textarea { flex: 2; box-sizing: border-box; min-width: 100%; height: 100px; padding: 2%; border-radius: 20px; font-family: AvenirBook; .font-base(16); color: @colorgris3; border: none; }\n    }\n\n    .cartInfo {margin-top: 20px; .font-base(14); line-height: 20px; text-align: justify;\n      b { font-family: AvenirBook; }\n    }\n  }\n\n  .paids {margin: 20px 0px 0px 0px; padding: 20px; border-radius: 20px; font-family: AvenirBook; .font-base(16); background-color: @colorgris1;\n    .title {height: 50px; margin-bottom:20px; font-family: AvenirBlack; .font-base(17); color: #000000;\n      input{margin-top:30px; height: 45px; padding-left: 10px; border-radius: 20px; }\n      input[type=radio] { width: 20px; height: 20px; margin-top:15px; margin-right: 10px; }\n    }\n\n    input.btnsubmit { max-width: 200px; padding: 0px; margin: 0px 0px 0px 0px; height:45px; line-height:50px; border-radius: 20px; font-family: AvenirBlack; .font-base(16); background-color: @colorazul1; text-align: center; cursor: pointer; border: none; }\n    input.btnsubmit:disabled { background-color: @colorgris2; cursor: initial; }\n\n    .creditcard { margin-bottom: 20px;\n      .inputs { display: grid; gap: 20px; grid-template-columns: repeat(2, minmax(150px, 1fr));\n        input { width: 100%; height: 45px; padding-left: 10px; border-radius: 20px; box-sizing: border-box; font-family: AvenirBook; .font-base(16); color: @colorgris3; border: none; }\n        .expirydate { display: flex; gap: 20px; width: 100%;\n          input { flex: 1; }\n        }\n        input.btnsubmit { justify-self: end; color: #FFFFFF; font-family: AvenirBlack; }\n      }\n    }\n\n    .securecreditcard {\n      .inputs { display: grid; gap: 20px; grid-template-columns: repeat(2, minmax(150px, 1fr));\n        input { width: 100%; }\n        input.btnsubmit { justify-self: end; color: #FFFFFF; font-family: AvenirBlack; }\n      }\n    }\n\n    .paypal {\n      .inputs{display: grid; gap: 20px; grid-template-columns: repeat(2, minmax(150px, 1fr));\n        input{width: 100%;}\n        input.btnsubmit {justify-self: end; color: #FFFFFF; font-family: AvenirBlack;}\n      }\n    }\n\n    .bizum {\n      .inputs{display: grid; gap: 20px; grid-template-columns: repeat(2, minmax(150px, 1fr));\n        input{width: 100%;}\n        input.btnsubmit {justify-self: end; color: #FFFFFF; font-family: AvenirBlack;}\n      }\n    }\n\n    .googlepay {\n      .inputs{display: grid; gap: 20px; grid-template-columns: repeat(2, minmax(150px, 1fr));\n        input{width: 100%;}\n        input.btnsubmit {justify-self: end; color: #FFFFFF; font-family: AvenirBlack;}\n      }\n    }\n\n    .creditcardicon{ display: inline-block; width: 93px; height: 25px; margin-left: 15px; vertical-align: middle; background: url(\"./assets/creditcard.webp\") -0px -0px;}\n    .paypalicon{ display: inline-block; width: 90px; height: 26px; margin-left: 15px; vertical-align: middle; background: url(\"./assets/paypal.webp\") -0px -0px;}\n    .bizumicon{ display: inline-block; width: 100px; height: 32px; margin-left: 15px; vertical-align: middle; background: url(\"./assets/bizum.webp\") -0px -0px;}\n    .googlepayicon{ display: inline-block; width: 70px; height: 37px; margin-left: 15px; vertical-align: middle; background: url(\"./assets/googlepay.webp\") -0px -0px;}\n\n    .conditions{.font-base(14);}\n    \n  }\n}\n\n//MODAL PAY\n.modalPay{position:fixed; top:0; left:0; width: 100%; height: 100%; z-index: 100;\n  .modalPayBackground{position: absolute; top:0; left:0; width: 100%; height: 100%; background-color: @colorgris4; opacity: 0.8; }\n  .modalPayContent{position: absolute; width: 400px; min-height: 250px; padding-block: 20px; background-color: #FFFFFF; border-radius: 10px; text-align: center;\n    top: 50%; left: 50%;\n    transform: translate(-50%, -50%);\n    .modalPayImg{margin:20px auto;}\n    .modalPayText{margin-bottom:5px; color: #666666;}\n    .modalPayGif{width:400px; height: 50px; margin-top: 20px; background: url(\"./assets/redirect.gif\") -200px -30px;}\n  }\n}\n\n@container cartForm (inline-size < 450px) {\n  .cartForm{\n    .paids{\n      .creditcard{\n        .inputs {\n          input{.font-base(15); }\n          .expirydate{.font-base(15);}\n        }\n      }\n      .creditcardicon{margin-top: 15px;}\n    }\n  }\n}\n\n\n\n","/*******************************************************\n *                                                     *\n *                VIAJES TEIDE                         *\n *                                                     *\n *        developed: Javier Vega Martinez              *\n *        contact: info@emdbwebprojects.com            *\n *        copyright - 2014-2024                        *\n *                                                     *\n *******************************************************/\n\n//VARS\n\n@colorverde1: #99CC33;  //verde 1\n@colorverde2: #009933;  //verde 2\n@colorverde3: #BEE266;  //verde 3\n@colorazul1: #33CCFF;   //azul 1\n@colorrosa1: #FF6698;   //rosa 1\n\n@colorgris1: #E1E1E1;   //Gris background footer\n@colorgris2: #999999;   //Gris text\n@colorgris3: #666666;   //Gris text\n@colorgris4: #333333;   //Gris text\n@colorgris5: #5D5D5D;\n\n/* width */\n@width-space:20px;\n@width-column:40px;\n@width-content: 1100px;\n@width-total: @width-content + 20px;\n@width-min:400px;\n\n/* fonts */\n@em:16px;\n\n@font-face {font-family: GTEestiBold; src: url('../fonts/GTEestiBold.otf'); }\n@font-face {font-family: AvenirBook; src: url('../fonts/AvenirBook.otf'); }\n@font-face {font-family: AvenirBlack; src: url('../fonts/AvenirBlack.ttf'); }\n@font-face {font-family: AvenirOblique; src: url('../fonts/AvenirOblique.otf'); }\n\n.font-base(@sizeValue) {\n  font-size: unit(( @sizeValue / @em ), em);\n}\n\n/* debug */\n.debug {background-color:#ff7f50;}\n.debug2 {background-color:#6495ed ;}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"debug": `debug-Ha9vG`,
	"debug2": `debug2-DjdLL`,
	"cartForm": `cartForm-Um0tD`,
	"errors": `errors-V572M`,
	"error": `error-HI_lG`,
	"clientInfo": `clientInfo-uDFaD`,
	"inputs": `inputs-JufC4`,
	"cartInfo": `cartInfo-Sh8g9`,
	"paids": `paids-GRZ8O`,
	"title": `title-l7Rhj`,
	"btnsubmit": `btnsubmit-jUyBq`,
	"creditcard": `creditcard-WU_A6`,
	"expirydate": `expirydate-nKCJj`,
	"securecreditcard": `securecreditcard-PDfwS`,
	"paypal": `paypal-S4KGb`,
	"bizum": `bizum-bIQzn`,
	"googlepay": `googlepay-r2U7r`,
	"creditcardicon": `creditcardicon-FynLh`,
	"paypalicon": `paypalicon-Jy8EE`,
	"bizumicon": `bizumicon-HrK04`,
	"googlepayicon": `googlepayicon-VGN3S`,
	"conditions": `conditions-IVhCY`,
	"modalPay": `modalPay-htdke`,
	"modalPayBackground": `modalPayBackground-BRHyA`,
	"modalPayContent": `modalPayContent-TNEIC`,
	"modalPayImg": `modalPayImg-zkU2p`,
	"modalPayText": `modalPayText-esM14`,
	"modalPayGif": `modalPayGif-DcNZO`
};
export default ___CSS_LOADER_EXPORT___;
